import { createBrowserRouter, Navigate } from 'react-router-dom';

import { SignInPage } from '@/modules/auth';
import { MainTemplate } from '@/modules/common/templates';
import { EventDetailsPage, EventsPage, NewEventPage } from '@/modules/events';
import { EventDetailsV2Page, EventsV2Page } from '@/modules/eventsV2';
import { EventDetailsTab } from '@/modules/eventsV2/constants';
import { GcrDetailsPage, GcrsPage, NewGcrPage } from '@/modules/gcrs';
import { InstanceManagerPage } from '@/modules/instances';
import { MaskDetailsPage, MasksPage, NewMaskPage } from '@/modules/masks';
import { ModelDetailsPage, ModelsPage, NewModelPage } from '@/modules/models';
import {
  NewOverlayPage,
  OverlayDetailsPage,
  OverlaysPage,
} from '@/modules/overlays';
import { LegalPage } from '@/modules/privacy-policy';
import { NewStylePage, StyleDetailsPage, StylesPage } from '@/modules/styles';

import { Routes } from './routes';

export const router = createBrowserRouter([
  {
    path: '*',
    element: <div>Not Found</div>,
  },
  {
    path: Routes.SignIn,
    element: <SignInPage />,
  },
  {
    path: Routes.PrivacyPolicy,
    element: <LegalPage />,
  },
  {
    path: Routes.Home,
    element: <MainTemplate />,
    children: [
      {
        path: '*',
        element: <div>Not Found</div>,
      },
      {
        path: Routes.Models,
        element: <ModelsPage />,
      },
      {
        path: Routes.ModelDetails,
        element: <ModelDetailsPage />,
      },
      {
        path: Routes.NewModel,
        element: <NewModelPage />,
      },
      {
        path: Routes.Styles,
        element: <StylesPage />,
      },
      {
        path: Routes.NewStyle,
        element: <NewStylePage />,
      },
      {
        path: Routes.StyleDetails,
        element: <StyleDetailsPage />,
      },
      {
        path: Routes.Masks,
        element: <MasksPage />,
      },
      {
        path: Routes.MaskDetails,
        element: <MaskDetailsPage />,
      },
      {
        path: Routes.NewMask,
        element: <NewMaskPage />,
      },
      {
        path: Routes.Events,
        element: <EventsPage />,
      },
      {
        path: Routes.EventsV2,
        element: <EventsV2Page />,
      },

      {
        path: Routes.NewEvent,
        element: <NewEventPage />,
      },
      {
        path: Routes.EventDetails,
        element: <EventDetailsPage />,
      },
      //NEW V2 EVENTS
      {
        path: Routes.EventsV2,
        element: <EventsV2Page />,
      },
      {
        path: `${Routes.EventDetailsV2}/:tab`,
        element: <EventDetailsV2Page />,
      },
      {
        path: `${Routes.EventDetailsV2}`,
        element: <Navigate to={EventDetailsTab.Info} replace />,
      },
      {
        path: Routes.Overlays,
        element: <OverlaysPage />,
      },
      {
        path: Routes.NewOverlay,
        element: <NewOverlayPage />,
      },
      {
        path: Routes.OverlayDetails,
        element: <OverlayDetailsPage />,
      },
      {
        path: Routes.InstancesManager,
        element: <InstanceManagerPage />,
      },
      {
        path: Routes.Gcrs,
        element: <GcrsPage />,
      },
      {
        path: Routes.NewGcr,
        element: <NewGcrPage />,
      },
      {
        path: Routes.GcrDetails,
        element: <GcrDetailsPage />,
      },
    ],
  },
]);
